export default __webpack_public_path__ + "ee932496cc9b3b2dbc6bed76db818888.svg";